import globalAgent from 'src/agent';

import type { Stream } from './agent';

export interface FreeStartStatus {
    amount: number;
    available: boolean;
    email_confirmed: boolean;
    telegram_connected: boolean;
    claimed_stream_id: number | null;
}

export const getFreeStartStatus = async (): Promise<FreeStartStatus> =>
    (await globalAgent.get<FreeStartStatus>('/streams/streams/free-start/')).data;

export const activateFreeStart = async (streamId: number): Promise<Stream> =>
    (await globalAgent.post<Stream>(`/streams/streams/${streamId}/activate-free-start/`)).data;
